import PurchaseOrderLineAdjustmentType from "../../../../shared/model/PurchaseOrderLineAdjustmentType";
import { Copies } from "../../../../shared/hooks/useCopies";
import { ApiDateTime } from "../../../../shared/types/ApiDateTime";
import DateTimeHelper from "shared/utils/dateTimeHelper";

export function getDateTimeToDisplay(date?: ApiDateTime) {
  if (!date?.dateTime) {
    return "";
  }
  try {
    return DateTimeHelper.formatDate({
      startDate: date.dateTime,
      timeZone: date.timeZoneDisplayStr,
      option: {
        showWeekDay: true,
        showTime: true
      }
    });
  } catch (e) {
    return "";
  }
}

export function getPurchaseOrderAdjustmentItemDescription(
  quantity: number,
  inventoryDisplayStr: string,
  lineAdjustmentType: PurchaseOrderLineAdjustmentType,
  copies: Copies
) {
  switch (lineAdjustmentType) {
    case PurchaseOrderLineAdjustmentType.PARTIAL_REMOVE:
      return copies.get("purchase.order.investment.debit", {
        0: quantity,
        1: inventoryDisplayStr
      });
    case PurchaseOrderLineAdjustmentType.ADD:
      return copies.get("purchase.order.investment.credit", {
        0: quantity,
        1: inventoryDisplayStr
      });
    case PurchaseOrderLineAdjustmentType.CANCEL:
      return copies.get("cancel");
    default:
      return "";
  }
}
